export const headings = {
  fontFamily: "Roboto, sans-serif",
  fontWeight: "bold",
  sizes: {
    h1: {
      fontSize: "1.5rem",
      lineHeight: "1.4em",
      fontWeight: "bold",
    },
    h2: {
      fontSize: "1.5rem",
      lineHeight: "1.4em",
      fontWeight: "bold",
    },
    h3: {
      fontSize: "1.5rem",
      lineHeight: "1.4em",
      fontWeight: "bold",
    },
    h4: {
      fontSize: "1.5rem",
      lineHeight: "1.4em",
      fontWeight: "bold",
    },
    h5: {
      fontSize: "1.25rem",
      lineHeight: "1.4em",
      fontWeight: "bold",
    },
    h6: {
      fontSize: "1rem",
      lineHeight: "1.4em",
      fontWeight: "bold",
    },
  },
};
